import { loader } from '@monaco-editor/react';

// Extend window type for Monaco preloading flag
declare global {
  interface Window {
    __monacoPreloaded?: boolean;
  }
}

// Configure Monaco to load from local assets instead of CDN
loader.config({
  paths: {
    vs: '/monaco-editor/min/vs'
  }
});

// Preload Monaco Editor to improve initial load time
export const preloadMonacoEditor = () => {
  // Only preload if not already loading
  if (window.__monacoPreloaded) return;
  window.__monacoPreloaded = true;

  // Use dynamic import to start loading Monaco in the background
  import('@monaco-editor/react').then(() => {
    return true;
  }).catch((err: unknown) => {
    console.error('Failed to preload Monaco Editor:', err);
    return false;
  });
};